import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { VFC } from 'react';

import { V2CreationOwner } from '@/apis/aniftyBackend/creations/interface';
import routes from '@/config/routes';
import { DEFAULT_PROFILE_IMAGE_PATH } from '@/constants/images';

import styles from './CreationOwnerList.module.scss';

type Props = V2CreationOwner;

const CreationOwnerItem: VFC<Props> = ({
  userID,
  displayName: _displayName,
  displayNameJA,
  profileImageURL: _profileImageURL,
  userName,
  holdingTokenAmount,
}: Props) => {
  const { i18n } = useTranslation();

  const linkHref = userName
    ? routes.creatorDetail(userName)
    : routes.myPage(userID);
  const profileImageURL = _profileImageURL || DEFAULT_PROFILE_IMAGE_PATH;
  const displayName =
    i18n.language === 'ja' ? displayNameJA || _displayName : _displayName;

  return (
    <Link href={linkHref}>
      <a className={styles.ownerLink}>
        <img
          src={profileImageURL}
          alt="profile image"
          className={styles.ownerProfileImage}
        />
        <div className={styles.ownerInfo}>
          <div className={styles.ownerDisplayName}>{displayName || userID}</div>
          <div className={styles.holdingInfo}>
            owning {holdingTokenAmount} edition
            {holdingTokenAmount >= 2 && 's'}
          </div>
        </div>
      </a>
    </Link>
  );
};

export default CreationOwnerItem;
